import DocInput from '@/components/DocInput.vue'
import { createInput } from '@formkit/vue'
export const docInput = createInput(DocInput, {
  props: ['docType', 'multiple', 'crewProfileId', 'disableTypeCheck']
})
